
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import BASE_URL from "../../BASEURL";

export default function ProductList() {
  const [categories, setCategories] = useState([]); // [{category, items}]
  const [categoryMap, setCategoryMap] = useState({}); // {id: name}
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      setError("");
      try {
        // Fetch categories
        const catRes = await fetch(`${BASE_URL}/api/category`);
        let catMap = {};
        if (catRes.ok) {
          const catJson = await catRes.json();
          (catJson.data || []).forEach((cat) => {
            catMap[cat._id || cat.id] = cat.name || cat.title || cat.slug;
          });
        }
        setCategoryMap(catMap);

        // Fetch products
        const res = await fetch(`${BASE_URL}/api/product`);
        if (!res.ok) throw new Error("Failed to fetch products");
        const json = await res.json();
        // Group products by category id
        const grouped = {};
        (json.data || []).forEach((prod) => {
const cat = (prod.category && prod.category.name) || "Uncategorized";          if (!grouped[cat]) grouped[cat] = [];
          grouped[cat].push(prod);
        });
        // Convert to array of { category, items }
        const arr = Object.keys(grouped).map((cat) => ({
          category: cat,
          items: grouped[cat],
        }));
        setCategories(arr);
      } catch (err) {
        setError(err.message || "Failed to fetch products");
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, []);

  if (loading) return <p className="p-10">Loading...</p>;
  if (error) return <p className="p-10 text-red-500">{error}</p>;

  return (
    <section className="max-w-7xl mx-auto md:p-6 space-y-10">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-3 justify-between">
        <h1 className="text-2xl font-bold text-primaryDark">All Products</h1>
        <Link
          to="/admin/products/add"
          className="bg-primary text-white px-5 py-2 rounded"
        >
          + Add Product
        </Link>
      </div>

      {categories.length === 0 && <p className="p-10">No products found.</p>}

      {categories.map((category) => (
        <div key={category.category} className="space-y-4">
          {/* CATEGORY TITLE */}
          <h2 className="text-xl font-semibold text-primary border-b pb-2">
            {category.category === "Uncategorized"
              ? "Uncategorized"
              : categoryMap[category.category] || category.category}
          </h2>

          {/* PRODUCTS GRID */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {category.items.map((item) => (
              <div
                key={item.slug}
                className="bg-white rounded-xl shadow hover:shadow-xl transition p-5"
              >
                <img
                  src={item.image}
                  alt={item.name}
                  className="h-40 mx-auto object-contain mb-4"
                />

                <h3 className="text-lg font-semibold mb-1">{item.name}</h3>
                <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                  {item.shortDesc}
                </p>

                <div className="flex gap-2">

                  <Link
                    to={`/admin/products/edit/${item._id || item.id}`}
                    className="px-3 py-1.5 text-sm border border-primaryDark text-primaryDark rounded hover:bg-primaryDark hover:text-white transition"
                    >
                    Edit
                  </Link>
                    <button
                      onClick={async () => {
                        if (!window.confirm('Are you sure you want to delete this product?')) return;
                        try {
                          const res = await fetch(`${BASE_URL}/api/product/${item._id || item.id}`, {
                            method: 'DELETE',
                          });
                          if (!res.ok) {
                            const txt = await res.text();
                            throw new Error(txt || 'Delete failed');
                          }
                          alert('Product deleted!');
                          // Refresh product list
                          setCategories((prev) => {
                            return prev.map(catObj => ({
                              ...catObj,
                              items: catObj.items.filter(prod => (prod._id || prod.id) !== (item._id || item.id))
                            })).filter(catObj => catObj.items.length > 0);
                          });
                        } catch (err) {
                          alert('Failed to delete product');
                        }
                      }}
                      className="px-3 py-1.5 text-sm border border-red text-red rounded hover:bg-danger hover:text-red transition"
                    >
                      Delete
                    </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
